import { render, staticRenderFns } from "./TrainingReport.vue?vue&type=template&id=60fcbd94"
import script from "./TrainingReport.vue?vue&type=script&lang=js"
export * from "./TrainingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports